/* eslint-disable max-len */
const React = require('react')
const PropTypes = require('prop-types')
const Form = require('react-form/lib/components/Form')
const Text = require('react-form/lib/components/form-fields/Text')
const TextArea = require('react-form/lib/components/form-fields/TextArea')
const Button = require('component/button')
const { isEmail } = require('lib/validator')
const { capitalize } = require('lib/text')
const displayFirstName = require('module/user/helpers/display_first_name')
const ErrorLabel = require('./error_label')
const MaxlengthLabel = require('./maxlength_label')
const Captcha = require('./captcha')
const log = require('log').create('contact form')  

const fields = ['name', 'email', 'message', 'token']
const name_maxlength = 50
const email_maxlength = 254
const message_maxlength = 400

class ContactMeForm extends React.Component {

    constructor(props) {
        super(props)

        this.onChange = this.onChange.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.onSubmitFailure = this.onSubmitFailure.bind(this)

        this.state = {
            submitting: false,
            show_errors: false,
            show_extras: false,
            valid: false,
        }
    }

    onChange(value, e, formApi) {
        const valid = this.isValid(formApi)
        // once show_extras is true, leave it true
        const show_extras = this.state.show_extras || valid
        this.setState({
            show_errors: false,
            valid,
            show_extras,
        })
    }

    onSubmit(values, e, formApi) {
        const Dialog = require('module/dialog/dialog')

        this.setState({
            submitting: true,
            show_extras: false,
        })

        this.sendMessage(values)
            .then(() => {
                Dialog.banner('Your message has been sent!', { duration: 10000 })
                formApi.resetAll()
                this.setState({
                    submitting: false,
                })
            })
            .catch(err => {
                log('err', err)
                Dialog.banner('There was an error sending your message. Please try again.', { status: 'warning' })
            })
    }

    onSubmitFailure(errors, e, formApi) {
        this.setState({
            show_errors: true,
        })
    }

    getButtonStyle() {
        const { color, luminance } = this.props
        if (luminance !== 'dark') return

        const button_color = `#${color}`

        const style = {
            color: button_color,
            borderColor: button_color,
        }

        return style
    }

    getFirstError(errors) {
        if (! errors) return {}
        if (! this.state.show_errors) return {}
        const error_objects = (
            fields
            // filter out the ones that don't have errors
                .filter(field => errors[field])
            // map each one to an object { field: message }
                .map(field => ({ [field]: errors[field] }))
        )
        // return the first one
        return error_objects[0]
    }

    sendMessage(values) {
        const $ = require('lib/jquery')
        const viewer = require('module/viewer/viewer')
        const { NODE_API } = this.context.globals
        const { user_name } = this.props.user

        const data = {
            user_name: viewer.get('user_name'),
            first_name: values.name,
            email: values.email,
            to: user_name,
            message: values.message,
            captcha_token: values.token,
            captcha_type: Captcha.getCaptchaType(),
        }

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                url: `${NODE_API}/user/${user_name}/send_email`,
                data: JSON.stringify(data),
                dataType: 'json',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .done(resolve)
                .fail(reject)
        })
    }

    isValid(formApi) {
        // fields.some(formApi.validate) returns true if there are any errors
        // so we invert that to get the value of isValid
        return ! fields.some(formApi.validate)
    }

    render() {
        const { user } = this.props
        const { show_extras, submitting } = this.state
        const button_style = this.getButtonStyle()

        return (
            <Form
                onSubmit={this.onSubmit}
                onSubmitFailure={this.onSubmitFailure}
                >
                {formApi => {

                    // this returns an object with a single key { field: message }
                    // representing the first errored field
                    // this allows us to pass errors.field to each ErrorLabel
                    // and it will receive undefined if that field isn't the first error
                    const errors = this.getFirstError(formApi.errors)

                    return (
                        <form onSubmit={formApi.submitForm} noValidate>
                            <fieldset className="contact-name">
                                <Text
                                    type="text"
                                    field="name"
                                    name="name"
                                    autoComplete="name"
                                    id="contact-me-name"
                                    className="input large fullwidth"
                                    placeholder="Name"
                                    maxLength={name_maxlength}
                                    validate={value => {
                                        if (! value) return 'Please enter your name.'
                                    }}
                                    onChange={(value, e) => this.onChange(value, e, formApi)}
                                    disabled={submitting}
                                    />
                                <ErrorLabel error={errors.name} htmlFor="contact-me-name" />
                            </fieldset>
                            <fieldset className="contact-email">
                                <Text
                                    type="email"
                                    field="email"
                                    name="email"
                                    autoComplete="email"
                                    id="contact-me-email"
                                    className="input large fullwidth"
                                    placeholder="Email"
                                    maxLength={email_maxlength}
                                    validate={value => {
                                        if (! value) return 'Please enter your email address.'
                                        if (! isEmail(value)) return 'Please enter a valid email address.'
                                    }}
                                    onChange={(value, e) => this.onChange(value, e, formApi)}
                                    disabled={submitting}
                                    />
                                <ErrorLabel error={errors.email} htmlFor="contact-me-email" />
                            </fieldset>
                            <fieldset className="contact-message">
                                <TextArea
                                    field="message"
                                    name="message"
                                    id="contact-me-message"
                                    className="input large fullwidth"
                                    placeholder="Message"
                                    maxLength={message_maxlength}
                                    rows="5"
                                    validate={value => {
                                        if (! value) return 'Please enter a message.'
                                    }}
                                    onChange={(value, e) => this.onChange(value, e, formApi)}
                                    disabled={submitting}
                                    />
                                <ErrorLabel error={errors.message} htmlFor="contact-me-message" />
                            </fieldset>
                            {
                                show_extras && (
                                    <fieldset>
                                        <div className="message-info">
                                            <div className="can-respond">
                                                {capitalize(displayFirstName(user))} can respond directly to your <span className="text nowrap">email address.</span>
                                            </div>
                                            <MaxlengthLabel
                                                text={formApi.values.message || ''}
                                                maxlength={message_maxlength}
                                                htmlFor="contact-me-message"
                                                />
                                        </div>
                                    </fieldset>
                                )
                            }
                            {
                                show_extras && (
                                    <fieldset className="contact-captcha">
                                        <Captcha
                                            onReceivedToken={token => formApi.setValue('token', token)}
                                            onExpiredToken={() => formApi.setValue('token', '')}
                                            />
                                        <Text
                                            type="hidden"
                                            field="token"
                                            name="token"
                                            id="contact-me-token"
                                            validate={value => {
                                                if (! value) return 'Please verify that you’re not a robot.'
                                            }}
                                            />
                                        <ErrorLabel error={errors.token} />
                                    </fieldset>
                                )
                            }
                            <fieldset className="contact-buttons">
                                <Button
                                    type="submit"
                                    size="large"
                                    className="fullwidth"
                                    style={button_style}
                                    loading={submitting}
                                    loading_text="Sending…"
                                    >
                                    Send
                                </Button>
                            </fieldset>
                        </form>
                    )
                }
            }
            </Form>
        )
    }
}

ContactMeForm.propTypes = {
    user: PropTypes.shape({
        user_name: PropTypes.string,
        contact_me: PropTypes.object,
    }).isRequired,
    color: PropTypes.string.isRequired,
    luminance: PropTypes.oneOf([
        'light',
        'dark',
    ]).isRequired,
}

ContactMeForm.contextTypes = {
    globals: PropTypes.object,
}

module.exports = ContactMeForm
